import React, { Component } from 'react'
import { connect } from 'react-redux'

class ShowWeakPasswordPopup extends Component {

    render() {
        return (
            <section class="overlay">
			<div class="overlay-window-container">
				<div class="overlay-window">
					<div class="overlay-content padding-0">
						<div class="overlay-header">
							<div class="overlay-header-title">
								<h2 style={{color: "#000 !important"}}>Attention</h2>
								<p>{this.props.message}</p>
							</div>
							<div class="overlay-header-icon">
								<i class="fas fa-lock"></i>
							</div>
						</div>
					</div>
					<div class="overlay-controls">
						<button class="button" onClick={this.props.onClick}>Re-type Password</button>
						{/* <button class="button secondary" onClick={this.props.onNoclick}>No</button> */}
					</div>
				</div>
			</div>
		</section>
        )
    }
}

const mapStateToProps = state => {
    return {
        stringConst: state.store.home.stringConst,
        menuColor: state.store.home.MenuColor,
        conformMessage: state.store2.confirmaionPopUp.msgToShow,
        compName: state.store.compName,


    }
}
export default ShowWeakPasswordPopup;